import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056c6e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cv-error-state" }
const _hoisted_2 = { class: "text-h6 mb-2" }
const _hoisted_3 = { class: "cv-error-body mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "cv-error-trace mb-0"
}
const _hoisted_5 = { class: "cv-error-actions mt-6" }

import { computed } from "vue";
import type { ApiErrorKind } from "@/services/useApiError";

/**
 * One rendering for every way a resource can fail to load, so the seven detail views and the
 * catch-all routes all say the same thing. Takes the classified `kind` rather than a raw
 * status code: the views deal in categories, not HTTP.
 *
 * Rendered in place of the content rather than navigated to, so the URL survives — the user
 * can reload it, bookmark it, or send it to whoever gave them the link.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceErrorState',
  props: {
    kind: {},
    costCenter: { type: Boolean },
    costCenterName: {},
    traceId: {},
    backTo: {},
    backLabel: { default: "Vissza" }
  },
  emits: ["retry"],
  setup(__props: any) {

const props = __props;



const forbiddenBody = () => {
  const where = props.costCenterName
    ? `a céged „${props.costCenterName}" költséghelyéhez tartozik`
    : "a céged egy másik költséghelyéhez tartozik";
  return `Ez az oldal ${where}. Kérj hozzáférést a céged adminisztrátorától.`;
};

// No status code in the headline: the user is not looking for one. The trace id is the
// exception, and it sits below — it exists for support, not for the reader.
const content = computed(() => {
  switch (props.kind) {
    case "notFound":
      return {
        icon: "mdi-file-question-outline",
        title: "A keresett oldal nem található",
        body: "Lehet, hogy törölték, vagy elgépelted a linket.",
      };
    case "forbidden":
      return props.costCenter
        ? {
            icon: "mdi-lock-outline",
            title: "Nincs hozzáférésed ehhez a költséghelyhez",
            body: forbiddenBody(),
          }
        : {
            icon: "mdi-lock-outline",
            title: "Ehhez a művelethez nincs jogosultságod",
            body: "Ha úgy gondolod, hogy hozzá kellene férned, jelezd a céged adminisztrátorának.",
          };
    default:
      return {
        icon: "mdi-cloud-off-outline",
        title: "A szolgáltatás átmenetileg nem elérhető",
        body: "Próbáld újra egy perc múlva. Ha a hiba továbbra is fennáll, jelezd nekünk.",
      };
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, {
      icon: content.value.icon,
      size: "56",
      class: "cv-error-icon mb-4"
    }, null, 8, ["icon"]),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(content.value.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(content.value.body), 1),
    (_ctx.traceId)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createTextVNode(" Hiba azonosító: "),
          _createElementVNode("code", null, _toDisplayString(_ctx.traceId), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.kind === 'unavailable')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            color: "primary",
            variant: "flat",
            "prepend-icon": "mdi-refresh",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Újrapróbálom ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.backTo)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            to: _ctx.backTo,
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.backLabel), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})